const ScheduleCell = ({ schedule }) => {
    return (
        <>
            {schedule.schedule_code ? <p className="mb-0 fw-bold text-primary"><small>{schedule.schedule_code}</small></p> : <p className="mb-0 fw-bold text-danger"><small>Not Set</small></p>}
            <p className="mb-0">{schedule.name}</p>
        </>
    )
}

export default ScheduleCell